import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';
function safeString(params) {
  return htmlSafe(params.join(''));
}
export default buildHelper(safeString);